/* istanbul ignore file */

export default {
  file: {
    type: 'array',
    required: true,
    maxSize: 1,
  },
};
